'use client';
import { createStyles } from '@s7/styles';

var useStyles = createStyles({
    body: {}
});

export { useStyles as default };
//# sourceMappingURL=ModalBody.styles.js.map
